module.exports = __webpack_public_path__ + "media/images/talent/feature03-125071e9ba5f6a135275fcd714fe2c54.png";